import React, { Suspense } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import NewUser from "./containers/newuser.container.js";
import ModifyUser from "./containers/modifyuser.container.js";
// import GlobalHomePage from "./components/GlobalHomePage/GlobalHome.js";
import UserHomePage from "./components/UserHomePage/UserHome.js";
import AccessApproval from "./components/AccessApprovalPage/AccessApproval.js";
import Privacy from "./components/PrivacyPage/Privacy.js";
import ContactUs from "./components/ContactUsPage/ContactUs.js";
import ProductAndRoles from "./components/ProductsandRolesPage/ProductsAndRoles_JP.js";
import DeleteUser from "./components/DeleteUserPage/DeleteUser.js";
import ConfirmationPage from "./components/ConfirmationPage/Confirmation.js";
import ThankYouPage from "./components/ThankYouPage/ThankYou.js";

function App() {
  return (
    <Suspense fallback="loading">
      <Router>
        <Route exact path="/" component={UserHomePage} />
        {/* <Route path="/home" component={UserHomePage} /> */}
        <Route path="/new-user" component={NewUser} />
        <Route path="/modify-user" component={ModifyUser} />
        <Route path="/access-approver" component={AccessApproval} />
        <Route path="/privacy-links" component={Privacy} />
        <Route path="/contact-us" component={ContactUs} />
        <Route path="/products-and-roles" component={ProductAndRoles} />
        <Route path="/delete-user" component={DeleteUser} />
        <Route path="/confirmation" component={ConfirmationPage} />
        <Route path="/thankyou" component={ThankYouPage} />
      </Router>
    </Suspense>
  );
}

export default App;
